/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";
import { DragDropContext, Droppable } from "react-beautiful-dnd";

import SkillModuleDetail from "./SkillModuleDetail";
import * as UpduoAnalytics from "config/UpduoAnalytics";

export default function SkillListView({
  _handleDragStart,
  _handleDragEnd,
  skillModulesList,
  canEdit,
  _handleDeactivateSkill,
  _handleDeactivateSkillModule,
  _handleCloneSkill,
  _handleCloneSkillModule,
}) {
  const _handleOnDragStart = (result) => {
    UpduoAnalytics.logEvent("user-skill-drag-start", {
      draggableId: result.draggableId,
    });
    _handleDragStart();
  };

  const _handleOnDragEnd = (result) => {
    UpduoAnalytics.logEvent("user-skill-drag-end", {
      sourceIndex: result.source.index,
      destinationIndex: result.destination ? result.destination.index : null,
      draggableId: result.draggableId,
    });
    _handleDragEnd(result);
  };

  return (
    <View
      style={{
        margin: 32,
      }}
    >
      <DragDropContext
        onDragStart={_handleOnDragStart}
        onDragEnd={_handleOnDragEnd}
      >
        <Droppable droppableId={"droppable"} type={"module"}>
          {(provided) => (
            <div ref={provided.innerRef}>
              {skillModulesList.map((item, itemIndex) => (
                <SkillModuleDetail
                  key={itemIndex}
                  skillList={item.activeSkillList}
                  skillModule={item}
                  skillModuleIndex={itemIndex}
                  canEdit={canEdit}
                  _handleDeactivateSkill={_handleDeactivateSkill}
                  _handleDeactivateSkillModule={_handleDeactivateSkillModule}
                  _handleCloneSkill={_handleCloneSkill}
                  _handleCloneSkillModule={_handleCloneSkillModule}
                />
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </View>
  );
}
